/* 무료배송 진행 바 — assets/free-shipping-bar.js
 *
 * Taiga 테마의 무료배송 알림(cart-shipping-notification)에 진행 바를 덧붙인다.
 *
 * 금액 계산을 따로 하지 않고 테마가 유지하는 값만 읽는다:
 *   data-cart-total      현지 통화 기준 장바구니 합계 (테마 JS가 갱신)
 *   data-threshold       스토어 기본 통화 기준 기준 금액
 *   data-shop-currency / data-target-currency
 *   .threshold-reached   달성 여부 (테마 JS가 토글)
 *
 * 환산 공식도 테마 cart.js 와 동일하게 Shopify.currency.rate 를 쓴다.
 *
 * ── 깜빡임 방지 ──────────────────────────────────────────────
 * 장바구니에 담을 때 테마가 헤더 섹션을 여러 번 다시 그린다.
 * (cart/add.js 이후 main-cart 2회 + recommendations 로 인한 header 1회)
 * 그때마다 알림 요소가 통째로 새 노드로 교체되므로,
 *   1) 처음 보는 노드에는 트랜지션 없이 즉시 너비를 맞추고
 *   2) 같은 합계에 대한 직전 메시지를 캐시해 "-" 플레이스홀더를 즉시 채운다.
 * 그래야 바가 0에서 다시 차오르거나 문구가 반복해서 나타나지 않는다.
 */
(function () {
  'use strict';

  if (window.__taigaShippingProgress) return;
  window.__taigaShippingProgress = true;

  var SELECTOR = '[data-free-shipping-notification]';
  var PLACEHOLDER = '-';

  var seen = [];                          // 이미 처리한 노드
  var cache = { total: null, message: '' }; // 같은 합계에 대한 마지막 문구
  var iconAnimatedTotal = null;           // 체크마크 애니메이션을 이미 보여준 합계
  var previousPercent = null;             // 직전에 그린 진행률

  /* 테마 cart.js 와 동일하게 환산한 기준 금액과 장바구니 합계.
     계산 불가면 null */
  function amounts(el) {
    var threshold = parseInt(el.getAttribute('data-threshold'), 10);
    var total = parseInt(el.getAttribute('data-cart-total'), 10);
    if (!threshold || threshold <= 0 || isNaN(total)) return null;

    var shopCurrency = el.getAttribute('data-shop-currency');
    var targetCurrency = el.getAttribute('data-target-currency');
    var rate = 1;

    if (shopCurrency && targetCurrency && shopCurrency !== targetCurrency) {
      rate =
        (window.Shopify &&
          window.Shopify.currency &&
          parseFloat(window.Shopify.currency.rate)) ||
        1;
    }

    var converted = threshold * rate;
    if (!converted) return null;

    return { total: total, threshold: converted };
  }

  /* 달성 비율 (0~1). 계산 불가면 null */
  function ratio(el) {
    var a = amounts(el);
    if (!a) return null;
    return Math.max(0, Math.min(a.total / a.threshold, 1));
  }

  /* 달성 여부. 테마와 같은 '초과'(>) 기준. 계산 불가면 null */
  function reached(el) {
    var a = amounts(el);
    if (!a) return null;
    return a.total > a.threshold;
  }

  /* 새로 그려진 노드의 "-" 플레이스홀더를 직전 문구로 즉시 채운다.
     합계가 같을 때만 쓰므로 낡은 문구가 보일 일은 없다. */
  function stabilizeMessage(el) {
    var msgEl = el.querySelector('.free-shipping-message');
    if (!msgEl) return;

    var total = el.getAttribute('data-cart-total');
    var text = msgEl.textContent.trim();

    if (text && text !== PLACEHOLDER) {
      cache.total = total;
      cache.message = text;
      return;
    }

    if (text === PLACEHOLDER && cache.message && cache.total === total) {
      msgEl.textContent = cache.message;
    }
  }

  function paint(el, snap) {
    stabilizeMessage(el);

    // 새로 그려진 노드는 테마 JS가 클래스를 붙이기 전이라
    // 체크마크 아이콘이 없다가 나타난다. 같은 공식으로 미리 맞춰 둔다.
    // (통화가 같은 경우에는 Liquid 가 이미 넣어두므로 대개 변화가 없다)
    if (snap) {
      var isReached = reached(el);
      if (isReached !== null) {
        el.classList.toggle('threshold-reached', isReached);

        // 체크마크 애니메이션은 '처음 달성했을 때' 한 번만 보이게 한다.
        // 같은 합계로 노드가 다시 그려지는 경우에는 억제한다.
        var currentTotal = el.getAttribute('data-cart-total');
        if (!isReached) {
          iconAnimatedTotal = null;
        } else if (iconAnimatedTotal === currentTotal) {
          el.classList.add('fsb-icon-animated');
        } else {
          iconAnimatedTotal = currentTotal;
        }
      }
    }

    var bar = el.querySelector('[data-shipping-progress]');
    var fill = el.querySelector('[data-shipping-progress-fill]');
    if (!bar || !fill) return;

    var r = ratio(el);
    if (r === null) {
      bar.hidden = true;
      return;
    }

    bar.hidden = false;
    var percent = Math.round(r * 1000) / 10;
    var width = percent + '%';

    if (snap) {
      // 새로 그려진 노드.
      // 값이 달라졌으면 직전 값에서 출발시켜 실제로 "움직이게" 한다.
      // (서버가 이미 최종 너비를 넣어 보내므로, 한 번 되돌린 뒤 다시 준다)
      // 값이 같으면 — 같은 장바구니로 여러 번 다시 그려지는 경우 —
      // 애니메이션 없이 그대로 둬서 깜빡이지 않게 한다.
      var from = previousPercent !== null && previousPercent !== percent
        ? previousPercent + '%'
        : width;

      fill.style.transition = 'none';
      fill.style.width = from;
      void fill.offsetWidth;  // 리플로우 강제 → 출발점 확정
      fill.style.transition = ''; // CSS 트랜지션 복구

      if (from !== width) fill.style.width = width;
    } else if (fill.style.width !== width) {
      // 같은 노드에서 값만 바뀐 경우 (수량 +/- 등) → 그대로 트랜지션
      fill.style.width = width;
    }

    previousPercent = percent;
    bar.setAttribute('aria-valuenow', String(Math.round(percent)));
  }

  /* 테마가 data-cart-total 을 바꾸거나 threshold-reached 를 토글할 때 */
  var attrObserver = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) paint(records[i].target, false);
  });

  function scan() {
    var nodes = document.querySelectorAll(SELECTOR);

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var isNew = seen.indexOf(el) === -1;

      if (isNew) {
        seen.push(el);
        attrObserver.observe(el, {
          attributes: true,
          attributeFilter: ['data-cart-total', 'class']
        });
      }

      paint(el, isNew);
    }

    // 떨어져 나간 노드 정리
    if (seen.length > 8) {
      seen = seen.filter(function (n) {
        return n.isConnected;
      });
    }
  }

  var timer = null;
  function scanSoon() {
    clearTimeout(timer);
    timer = setTimeout(scan, 60);
  }

  /* 섹션 렌더링으로 노드가 교체되는 것을 잡는다.
     스토어프론트에서는 shopify:section:load 가 발생하지 않으므로
     DOM 변화를 직접 본다.

     알림 노드가 새로 들어온 경우에는 디바운스하지 않고 즉시 처리한다.
     MutationObserver 콜백은 다음 페인트 전에 실행되므로, 여기서
     클래스를 붙여야 체크마크 애니메이션이 화면에 나타나기 전에 막힌다.
     그 외의 DOM 변화는 디바운스해서 가볍게 넘긴다. */
  function hasNotification(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches && node.matches(SELECTOR)) return true;
    return !!(node.querySelector && node.querySelector(SELECTOR));
  }

  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (hasNotification(added[j])) {
          clearTimeout(timer);
          scan();
          return;
        }
      }
    }
    scanSoon();
  }).observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', scanSoon);
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) scanSoon();
  });
})();